// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Login · Paper of Record · Split layout ── */

.login-page {
  display: flex;
  min-height: 100vh;
}

/* ── Brand pane (left) ── */
.login-brand {
  width: 40%;
  background: var(--ink-dark);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
  position: relative;
}

.login-brand::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      ellipse at 30% 40%,
      rgba(34, 184, 230, 0.07) 0%,
      transparent 60%
    ),
    radial-gradient(
      ellipse at 70% 70%,
      rgba(242, 227, 181, 0.04) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.login-logo {
  width: 200px;
  height: auto;
  position: relative;
}

.login-tagline {
  margin-top: 24px;
  font-family: var(--font-mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgba(242, 227, 181, 0.4);
  position: relative;
}

/* ── Form pane (right) ── */
.login-form-pane {
  flex: 1;
  background: var(--paper);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 52px;
}

.login-form {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
}

/* ── Selector Abogado | Receptor: las pestañas de src/ui/Tabs, como enlaces ── */
.login-portal {
  display: flex;
  border-bottom: 1px solid var(--rule);
  margin: 0 0 28px;
}

.login-portal__tab {
  flex: 1;
  position: relative;
  padding: 12px 8px;
  text-align: center;
  font-family: var(--font-sans);
  font-size: var(--fs-ui);
  color: var(--ink-3);
  text-decoration: none;
  transition: color 100ms ease;
}

.login-portal__tab:hover {
  color: var(--ink-2);
}

.login-portal__tab:focus-visible {
  outline: 2px solid var(--signal);
  outline-offset: -2px;
}

.login-portal__tab[aria-current='page'] {
  color: var(--ink);
  font-weight: 500;
}

.login-portal__tab[aria-current='page']::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: var(--signal);
}

.login-portal__tab[aria-disabled='true'] {
  opacity: 0.55;
  cursor: not-allowed;
}

.login-portal__tab[aria-disabled='true']:hover {
  color: var(--ink-3);
}

.login-eyebrow {
  font-family: var(--font-mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--ink-3);
  margin: 0 0 8px;
}

.login-heading {
  font-family: var(--font-display);
  font-size: var(--fs-h2);
  font-weight: 400;
  color: var(--ink);
  letter-spacing: -0.01em;
  margin: 0 0 28px;
  line-height: 1.15;
}

/* Public post-pay return: the outcome is the title, not an alert box. */
.login-form--payment-result {
  max-width: 26rem;
}

.login-heading--payment {
  font-size: var(--fs-title);
  font-weight: 500;
  letter-spacing: var(--display-tracking);
  line-height: 1.08;
  margin: 0 0 18px;
}

.recover-subtitle {
  font-size: var(--fs-ui);
  color: var(--ink-2);
  line-height: 1.5;
  margin: 0 0 20px;
}

.login-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.login-label {
  font-family: var(--font-mono);
  font-size: var(--fs-nano);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--ink-3);
}

/* ── Password visibility toggle ── */
.login-password-wrapper {
  position: relative;
}

.login-password-wrapper .form-input {
  width: 100%;
  padding-right: 36px;
}

.login-password-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: var(--ink-3);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--r-1);
  line-height: 0;
}

.login-password-toggle:hover {
  color: var(--ink);
}

/* ── Alert states ── */
.login-alert {
  border-radius: var(--r-data);
  padding: 9px 12px;
  font-size: var(--fs-2xs);
  line-height: 1.4;
  margin: 0;
}

.login-alert--err {
  background: var(--err-bg);
  color: var(--err);
  border: 1px solid rgba(180, 35, 24, 0.2);
}

.login-alert--ok {
  background: var(--ok-bg);
  color: var(--ok);
  border: 1px solid rgba(17, 122, 57, 0.2);
}

.login-alert--info {
  background: #eff6ff;
  color: #175cd3;
  border: 1px solid rgba(23, 92, 211, 0.2);
}

/* ── Captcha wrapper ── */
/* Turnstile renders at a fixed 300px (size: 'normal'); the form column is
 * wider, so we center the widget horizontally instead of letting it sit
 * left-aligned. The widget is hidden by default (appearance: 'execute') and
 * only appears during an interactive challenge, but the centering still
 * applies to that brief visible state. */
.login-captcha {
  display: flex;
  justify-content: center;
}

/* ── Submit button ── */
.login-submit {
  width: 100%;
}

/* ── Terms acceptance row (account activation and invitation accept) ── */
.login-terms {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--fs-2xs);
  color: var(--ink-2);
}

/* Wraps the checkbox and its text so clicking the text toggles it. The terms
   link stays outside: a label admits a single labelable descendant. */
.login-terms__accept {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.login-terms-link {
  background: none;
  border: none;
  padding: 0;
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
}

/* ── Forgot password link ── */
.login-forgot {
  display: block;
  text-align: center;
  font-size: var(--fs-2xs);
  color: var(--blue);
  margin-top: 16px;
  text-decoration: none;
}

.login-forgot:hover {
  text-decoration: underline;
}

/* ── Mobile: brand → slim top banner ── */
@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
  }

  .login-brand {
    width: 100%;
    min-height: unset;
    padding: 20px 24px;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
  }

  .login-logo {
    width: 90px;
  }

  .login-tagline {
    margin-top: 0;
  }

  .login-form-pane {
    padding: 32px 24px;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/login.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;;;;;KAUG;EACH,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;;;;yCAIyC;AACzC;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;sEACsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF","sourcesContent":["/* ── Login · Paper of Record · Split layout ── */\n\n.login-page {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* ── Brand pane (left) ── */\n.login-brand {\n  width: 40%;\n  background: var(--ink-dark);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 40px;\n  position: relative;\n}\n\n.login-brand::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(\n      ellipse at 30% 40%,\n      rgba(34, 184, 230, 0.07) 0%,\n      transparent 60%\n    ),\n    radial-gradient(\n      ellipse at 70% 70%,\n      rgba(242, 227, 181, 0.04) 0%,\n      transparent 50%\n    );\n  pointer-events: none;\n}\n\n.login-logo {\n  width: 200px;\n  height: auto;\n  position: relative;\n}\n\n.login-tagline {\n  margin-top: 24px;\n  font-family: var(--font-mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: rgba(242, 227, 181, 0.4);\n  position: relative;\n}\n\n/* ── Form pane (right) ── */\n.login-form-pane {\n  flex: 1;\n  background: var(--paper);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 52px;\n}\n\n.login-form {\n  width: 100%;\n  max-width: 340px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Selector Abogado | Receptor: las pestañas de src/ui/Tabs, como enlaces ── */\n.login-portal {\n  display: flex;\n  border-bottom: 1px solid var(--rule);\n  margin: 0 0 28px;\n}\n\n.login-portal__tab {\n  flex: 1;\n  position: relative;\n  padding: 12px 8px;\n  text-align: center;\n  font-family: var(--font-sans);\n  font-size: var(--fs-ui);\n  color: var(--ink-3);\n  text-decoration: none;\n  transition: color 100ms ease;\n}\n\n.login-portal__tab:hover {\n  color: var(--ink-2);\n}\n\n.login-portal__tab:focus-visible {\n  outline: 2px solid var(--signal);\n  outline-offset: -2px;\n}\n\n.login-portal__tab[aria-current='page'] {\n  color: var(--ink);\n  font-weight: 500;\n}\n\n.login-portal__tab[aria-current='page']::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 2px;\n  background: var(--signal);\n}\n\n.login-portal__tab[aria-disabled='true'] {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.login-portal__tab[aria-disabled='true']:hover {\n  color: var(--ink-3);\n}\n\n.login-eyebrow {\n  font-family: var(--font-mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--ink-3);\n  margin: 0 0 8px;\n}\n\n.login-heading {\n  font-family: var(--font-display);\n  font-size: var(--fs-h2);\n  font-weight: 400;\n  color: var(--ink);\n  letter-spacing: -0.01em;\n  margin: 0 0 28px;\n  line-height: 1.15;\n}\n\n/* Public post-pay return: the outcome is the title, not an alert box. */\n.login-form--payment-result {\n  max-width: 26rem;\n}\n\n.login-heading--payment {\n  font-size: var(--fs-title);\n  font-weight: 500;\n  letter-spacing: var(--display-tracking);\n  line-height: 1.08;\n  margin: 0 0 18px;\n}\n\n.recover-subtitle {\n  font-size: var(--fs-ui);\n  color: var(--ink-2);\n  line-height: 1.5;\n  margin: 0 0 20px;\n}\n\n.login-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.login-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.login-label {\n  font-family: var(--font-mono);\n  font-size: var(--fs-nano);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--ink-3);\n}\n\n/* ── Password visibility toggle ── */\n.login-password-wrapper {\n  position: relative;\n}\n\n.login-password-wrapper .form-input {\n  width: 100%;\n  padding-right: 36px;\n}\n\n.login-password-toggle {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: var(--ink-3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--r-1);\n  line-height: 0;\n}\n\n.login-password-toggle:hover {\n  color: var(--ink);\n}\n\n/* ── Alert states ── */\n.login-alert {\n  border-radius: var(--r-data);\n  padding: 9px 12px;\n  font-size: var(--fs-2xs);\n  line-height: 1.4;\n  margin: 0;\n}\n\n.login-alert--err {\n  background: var(--err-bg);\n  color: var(--err);\n  border: 1px solid rgba(180, 35, 24, 0.2);\n}\n\n.login-alert--ok {\n  background: var(--ok-bg);\n  color: var(--ok);\n  border: 1px solid rgba(17, 122, 57, 0.2);\n}\n\n.login-alert--info {\n  background: #eff6ff;\n  color: #175cd3;\n  border: 1px solid rgba(23, 92, 211, 0.2);\n}\n\n/* ── Captcha wrapper ── */\n/* Turnstile renders at a fixed 300px (size: 'normal'); the form column is\n * wider, so we center the widget horizontally instead of letting it sit\n * left-aligned. The widget is hidden by default (appearance: 'execute') and\n * only appears during an interactive challenge, but the centering still\n * applies to that brief visible state. */\n.login-captcha {\n  display: flex;\n  justify-content: center;\n}\n\n/* ── Submit button ── */\n.login-submit {\n  width: 100%;\n}\n\n/* ── Terms acceptance row (account activation and invitation accept) ── */\n.login-terms {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--fs-2xs);\n  color: var(--ink-2);\n}\n\n/* Wraps the checkbox and its text so clicking the text toggles it. The terms\n   link stays outside: a label admits a single labelable descendant. */\n.login-terms__accept {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.login-terms-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--blue);\n  text-decoration: underline;\n  cursor: pointer;\n  font: inherit;\n}\n\n/* ── Forgot password link ── */\n.login-forgot {\n  display: block;\n  text-align: center;\n  font-size: var(--fs-2xs);\n  color: var(--blue);\n  margin-top: 16px;\n  text-decoration: none;\n}\n\n.login-forgot:hover {\n  text-decoration: underline;\n}\n\n/* ── Mobile: brand → slim top banner ── */\n@media (max-width: 768px) {\n  .login-page {\n    flex-direction: column;\n  }\n\n  .login-brand {\n    width: 100%;\n    min-height: unset;\n    padding: 20px 24px;\n    flex-direction: row;\n    justify-content: center;\n    gap: 16px;\n  }\n\n  .login-logo {\n    width: 90px;\n  }\n\n  .login-tagline {\n    margin-top: 0;\n  }\n\n  .login-form-pane {\n    padding: 32px 24px;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
